import { UpdateSelectionDataAction } from 'modules/shared-menu/hooks/useSelectionData';
import { OfferOverrides, OfferWithSelectionAndAuthor } from 'modules/shared-menu/types';

export const availableOverridesBulkActions: (keyof OfferOverrides)[] = ['enabled'];

export const canSharedVenueUseBulkActions = (fieldsEnabledInSettings: (keyof OfferOverrides)[]) => {
  return fieldsEnabledInSettings.some(field => availableOverridesBulkActions.includes(field));
};

export const updateLocalSelectionData = (
  offers: OfferWithSelectionAndAuthor[],
  updateSelectionData: (action: UpdateSelectionDataAction) => void,
) => {
  offers.map(offer => {
    const { author, selection_id, ...baseOffer } = offer;
    updateSelectionData({
      actionType: 'updateOffer',
      payload: {
        ...baseOffer,
        scope: {
          type: 'selection',
          id: selection_id,
        },
      },
    });
  });
};
